export const TABLE_PHONE_COLUMN_WIDTH = 110;

export { useClientPagination } from './use-client-pagination';
export { useTablePageSize } from './use-table-page-size';
export { getColumnsList } from './get-columns-list';
